const filterOptions = (candidate, input) => {
  if (input) {
    return candidate.label.toLowerCase().includes(input.toLowerCase());
  }
  return true;
};
export default filterOptions;
